export const setStore = (payload) => ({
    type: 'REPLACE_STATE',
    payload
});